import React from 'react';
import { cn } from '../../lib/utils';

export function BrandLoader({
  message = 'Loading',
  size = 'md',
  tone = 'default',
  className,
}) {
  return (
    <div
      className={cn(
        'm9-loader-block',
        tone === 'exam' && 'm9-loader-block--exam',
        className,
      )}
      role="status"
      aria-live="polite"
      aria-busy="true"
      data-testid="brand-loader"
    >
      <div className="m9-loader" data-size={size} data-tone={tone} aria-hidden="true">
        <svg className="m9-loader__ring" viewBox="0 0 72 72">
          <circle className="m9-loader__track" cx="36" cy="36" r="30" />
          <circle className="m9-loader__arc" cx="36" cy="36" r="30" />
        </svg>
        <span className="m9-loader__mark">
          900<span className="m9-loader__dot">.</span>
        </span>
      </div>
      {message ? <p className="m9-loader__label">{message}</p> : null}
    </div>
  );
}

export const PageLoader = ({
  message = 'Loading',
  tone = 'default',
  size = 'md',
  compact = false,
}) => {
  return (
    <div
      className={cn('m9-loader-page', compact && 'm9-loader-page--compact')}
      data-testid="page-loader"
    >
      <BrandLoader message={message} size={size} tone={tone} />
    </div>
  );
};

export const FullPageLoader = ({
  message = 'Loading',
  tone = 'default',
}) => {
  return (
    <div
      className={cn(
        'm9-loader-screen',
        tone === 'exam' && 'm9-loader-screen--exam',
      )}
      data-testid="full-page-loader"
    >
      <BrandLoader message={message} size="lg" tone={tone} />
    </div>
  );
};

export const InlineLoader = ({
  message = 'Loading',
  tone = 'default',
  size = 'sm',
}) => {
  return (
    <div className="m9-loader-inline" data-testid="inline-loader">
      <BrandLoader message={message} size={size} tone={tone} />
    </div>
  );
};
